import { useAtomValue } from 'jotai';
import { PersonJSONLD } from '~/utils/json-ld/person';
import { ProfileJSONLD } from '~/utils/json-ld/profile';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { FC } from 'react';

export const JsonLD: FC = () => {
  const user = useAtomValue($CurrentAvailableUserOrNull);
  const { region } = useAtomValue($Locale);

  if (!user) {
    return null;
  }

  return (
    <>
      <PersonJSONLD
        name={user.nickName}
        uniqueName={user.linkName}
        url={`/${user.linkName}?region=${region}`}
        desc={user.description.replace(/\s+/g, ' ')}
        likeCount={user.dugCount + user.favoredCount}
        followCount={user.followingCount + user.followerCount}
        postCount={user.postCount}
        avatar={user.avatar}
      />
      <ProfileJSONLD
        name={user.nickName}
        uniqueName={user.linkName}
        desc={user.description.replace(/\s+/g, ' ')}
        avatar={user.avatar}
        likeCount={user.dugCount + user.favoredCount}
        followCount={user.followingCount + user.followerCount}
        favoriteCount={user.dugCount + user.favoredCount}
        postCount={user.postCount}
      />
    </>
  );
};
